import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

import { Comunicado } from '../../../base/vo/comunicado';
import { ComunicadosService } from '../../../comunicados/comunicados.service';

@Component({
    selector: 'app-ultimos-comunicados-importante',
    templateUrl: './ultimos-comunicados-importante.component.html',
    styleUrls: ['./ultimos-comunicados-importante.component.css']
})
export class UltimosComunicadosImportanteComponent implements OnInit {

    @Input() indice: number;
    @Input() comunicado: Comunicado;

    @Output() buscarUltimosComunicadosEvent = new EventEmitter();

    constructor(private comunicadoService: ComunicadosService) { }

    ngOnInit() {
    }

    private estouDeAcordo(comunicadoId: string){
        this.comunicadoService.estouDeAcordo(comunicadoId)
            .subscribe(
                data=> {
                    this.buscarUltimosComunicadosEvent.emit();
                },
                err=> {
                    console.log('Mensagem de erro')
                }
            );
    }

}



// WEBPACK FOOTER //
// ./src/app/components/dashboard/ultimos-comunicados/ultimos-comunicados-importante/ultimos-comunicados-importante.component.ts